import { sendGet, sendGetBlob, sendPost, type Response, type BlobResponse } from '../../hooks/use-fetch'
import { type DashboardModel } from '../../models/peerToPeer/Dashboard'
import { type CompletionsView } from '../../models/peerToPeer/Collection'
import { type ReminderResult } from '../../models/peerToPeer/Reminders'

export interface RemindRequest {
  organizationId: number
  reportingYearId: number
  targetDistrictOrganizationIds?: number[]
}

export interface P2PFilterOrganization {
  id: number
  name: string
  type: string
}

export async function GetP2PDashboard (organizationId: number, reportingYearId: number): Promise<Response<DashboardModel>> {
  return await sendGet(`PeerToPeer/Dashboard?organizationId=${organizationId}&reportingYearId=${reportingYearId}`)
}

export async function GetP2PDashboardFilterOrganizations (reportingYearId: number): Promise<Response<P2PFilterOrganization[]>> {
  return await sendGet(`PeerToPeer/Dashboard/FilterOrganizations?reportingYearId=${reportingYearId}`)
}

export async function GetP2PCompletions (reportingYearId: number): Promise<Response<CompletionsView>> {
  return await sendGet(`PeerToPeer/Dashboard/Completions?reportingYearId=${reportingYearId}`)
}

export async function ExportP2PCsv (organizationId: number, reportingYearId: number, goal?: string): Promise<BlobResponse> {
  const goalParam = goal != null && goal !== '' ? `&goal=${encodeURIComponent(goal)}` : ''
  return await sendGetBlob(`PeerToPeer/Export/Csv?organizationId=${organizationId}&reportingYearId=${reportingYearId}${goalParam}`)
}

export async function SendP2PReminders (request: RemindRequest): Promise<Response<ReminderResult>> {
  return await sendPost('PeerToPeer/Dashboard/Remind', request)
}
